import React from "react";
import PropTypes from 'prop-types';

import { Button } from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';

const SaveButton = ({ handleSaveClick, label, isSaving, disabled, ...props }) => {
    return(
        <Button
            color="primary" 
            size="small"
            variant="contained"
            onClick={() => handleSaveClick()}
            disabled={isSaving || disabled}
            startIcon={<SaveIcon />}
            {...props}
        >
            {label ? label: 'Сохранить'}
        </Button>
    )
}


SaveButton.propTypes = {
    handleSaveClick: PropTypes.func
};

export default SaveButton;
